import React, { useEffect } from 'react';
import './StandStateDiagramView.css';
import ScatterChart from 'components/charts/MultipleScatterChart/ScatterChart';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import CanopyCoverChart from 'components/charts/CanopyCoverChart/CanopyCoverChart';
import { Point, ILineData } from 'components/charts/MultipleScatterChart/components/Area';
import { CalculateCanopyCoverDBHRRBySpecies, GetCanopyCoverBySpecies, GetCanopyCoverFromLRR_DBH } from 'services/RunApplication';
import { calculate_reliability_index } from 'utils/reliability_index';
import StandStateDiagramViewRow  from './StandStateDiagramViewRow';
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const labels = { x: "DBH (cm)", y: "Stand Density (Tress/ha)" };

function StandStateDiagramView() {

  const [data, setData] = React.useState<ILineData[]>([]);
  const [avgPoint, setAvgPoint] = React.useState<Point>([-1, -1]);
  const WASMApplicationState = useSelector((state: RootState) => state.WASMApplication);
  const results = useSelector((state: RootState) => state.WASMApplicationResult);
  const [rootReinforcementParams, setRRParams] = React.useState({ start: 0, end: 20000, step: 1000 });
  const [canopyCoverChartBeta, setCanopyCoverChartBeta] = React.useState<number[]>([]);
  const [canopyCoverChartDBH, setCanopyCoverChartDBH] = React.useState<Map<number, { lrr: number, canopy_cover: number }[]>>(new Map());
  const [markData, setMarkData] = React.useState<{ lrr: number, canopy_cover: number }>({ lrr: -1, canopy_cover: -1 });
  const [species, setSpecies] = React.useState<{name: string, index: number}[]>([]);
  const [currentSpecies, setCurrentSpecies] = React.useState<{name: string, index: number}>({ name: "None", index: -1});

  useEffect(() => {
    //Let's update the names we have available
    let species_used = []
    for (let k of Object.keys(WASMApplicationState.speciesDensity).map(Number)) {
      if ( WASMApplicationState.speciesDensity[k] === 0 ) continue;

      species_used.push({name: WASMApplicationState.species[k], index: k})
    }
    setSpecies(species_used);
  }, [WASMApplicationState.treeDBH, WASMApplicationState.speciesDensity]);

  return (
    <div>
      <Container fluid>
        {
          species.map((specie, index) => {
            return <StandStateDiagramViewRow key={`ssdv-${index}`} currentSpecies={specie}/>
          })
        }
      </Container>
    </div>
  );
}

export default StandStateDiagramView;
